import _ from 'lodash';
import { UserIcon } from 'lucide-react';
import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { UserResponse } from '../../../server/response/responseScheme';
import firebaseStore from '../../stores/firebaseStore';
import modalStore from '../../stores/modalStore';
import { apiClient } from '../../utils/apiClient';
import { useMobxInstance } from '../../utils/mobxUtil';

class ViewStore {
    currentUser: UserResponse | null = null;
    isLoading = false;

    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {
        this.isLoading = true;

        const isLoggedIn = await firebaseStore.isLoggedIn();

        if (isLoggedIn) {
            try {
                const currentUser = await apiClient.user.member.getCurrentUser.query();
                runInAction(() => {
                    this.currentUser = currentUser;
                    this.isLoading = false;
                });
            } catch (e) {
                // 토큰이 유효하지 않은 경우임
                runInAction(() => {
                    this.currentUser = null;
                    this.isLoading = false;
                });
            }
        } else {
            runInAction(() => {
                this.currentUser = null;
                this.isLoading = false;
            });
        }
    }
}

const UserProfile = observer(() => {
    const viewStore = useMobxInstance(ViewStore);

    useEffect(() => {
        viewStore.fetch();
    }, [firebaseStore.me]);

    const shouldShowLoading = !firebaseStore.isInitialized || viewStore.isLoading;

    return (
        <section className="py-4">
            {shouldShowLoading && (
                <div className="flex h-12 w-full items-center justify-center">
                    <div className="loading loading-ring"></div>
                </div>
            )}
            {!shouldShowLoading && viewStore.currentUser && (
                <div className="flex flex-row items-center gap-4">
                    {viewStore.currentUser.picture ? (
                        <div className="avatar">
                            <div className="w-12 rounded-full">
                                <img src={viewStore.currentUser.picture} />
                            </div>
                        </div>
                    ) : (
                        <div className="avatar avatar-placeholder">
                            <div className="bg-base-content/10 w-12 rounded-full">
                                <span className="text-xl">
                                    {_.first(viewStore.currentUser.name) || ''}
                                </span>
                            </div>
                        </div>
                    )}
                    <div className="flex flex-col justify-center">
                        <div className="text-base font-semibold">{viewStore.currentUser.name}</div>
                        <div className="text-base-content/70 text-sm">
                            {viewStore.currentUser.email}
                        </div>
                    </div>
                </div>
            )}
            {!shouldShowLoading && !viewStore.currentUser && (
                <button
                    className="flex flex-row items-center gap-4"
                    onClick={async () => {
                        await modalStore.login();
                    }}
                >
                    <div className="avatar avatar-placeholder">
                        <div className="bg-base-content/10 w-12 overflow-hidden rounded-full">
                            <UserIcon className="text-base-content/15 size-8" />
                        </div>
                    </div>
                    <div className="flex flex-col justify-center">
                        <div className="link link-hover text-base">로그인하고 시작하기 &gt;</div>
                    </div>
                </button>
            )}
        </section>
    );
});

export default UserProfile;
